import {
  DescriptionPage_ProductVariant as DescriptionPageProductVariant,
  Specialization_ProductVariant as S12nProductVariant,
} from '__generated__/graphql-types';

import { PROF_CERTS_USING_SKILL_CERT_LABEL } from 'bundles/unified-description-page-common/constants';

import _t from 'i18n!nls/unified-common';

/**
 * @description This function is used to get the product title for a given product variant.
 */
const getProductTitle = (
  name: string,
  productVariant?: DescriptionPageProductVariant | S12nProductVariant,
  slug?: string
) => {
  if (
    productVariant &&
    (productVariant === DescriptionPageProductVariant.StandardSpecialization ||
      productVariant === S12nProductVariant.NormalS12N)
  ) {
    return _t('#{name} Specialization', { name });
  } else if (
    slug &&
    productVariant &&
    (productVariant === DescriptionPageProductVariant.ProfessionalCertificate ||
      productVariant === S12nProductVariant.ProfessionalCertificateS12N) &&
    PROF_CERTS_USING_SKILL_CERT_LABEL.includes(slug)
  ) {
    return _t('#{name} Skill Certificate', { name });
  } else if (
    productVariant &&
    (productVariant === DescriptionPageProductVariant.ProfessionalCertificate ||
      productVariant === DescriptionPageProductVariant.GoogleCertificate ||
      productVariant === S12nProductVariant.GoogleCertificateS12N ||
      productVariant === S12nProductVariant.ProfessionalCertificateS12N)
  ) {
    return _t('#{name} Professional Certificate', { name });
  }

  return name;
};

export default getProductTitle;
